import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin.routing';
import { FormsModule } from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import {CollaboService} from '../collabo/collabo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import {AdminComponent} from './admin.component';
import { LocationComponent } from './location/location.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SkillsComponent } from './skills/skills.component';
import { UsersComponent } from './users1/users.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { AddUsersComponent } from './users1/addusers.component';
import { CollabosComponent } from './collabos/collabos.component';
import {LoginService} from '../../login-service';
import { AdminSignupComponent } from './admin-signup/admin-signup.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { RolesComponent } from './roles/roles.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CmsComponent } from './cms/cms.component';
import { AdminprofileComponent } from './adminprofile/adminprofile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmailComponent } from './email/email.component';

import { Category1Component } from './category1/category1.component';

import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MatSelectModule } from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import { PlansComponent } from './plans/plans.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ServicechargeComponent } from './servicecharge/servicecharge.component';
import { FinancialDashboardComponent } from './financial-dashboard/financial-dashboard.component';
@NgModule({
    imports: [CKEditorModule,CommonModule,AdminRoutingModule,MatSlideToggleModule,FormsModule,BrowserModule,CdkAccordionModule,BrowserAnimationsModule,ReactiveFormsModule,NgbModule,MatCheckboxModule,NgSelectModule,MatSelectModule,MatRadioModule,ModalModule],
    exports: [],
    declarations: [AdminComponent,AdminprofileComponent,Category1Component, DashboardComponent, SkillsComponent,LocationComponent,UsersComponent,AddUsersComponent,CollabosComponent, AdminSignupComponent, RolesComponent, CmsComponent,ChangePasswordComponent, EmailComponent,PlansComponent, ServicechargeComponent, FinancialDashboardComponent],
    providers: [CollaboService,LoginService],
})
export class AdminModule { }
